import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumb.css";


const humanize = (slug = "") =>
  slug
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const Breadcrumb = () => {
  const location = useLocation();

  if (location.pathname === "/") {
    return null;
  }

  if (location.pathname === "/ems" || location.pathname.startsWith("/ems?")) {
    return null;
  }

  const pathnames = location.pathname.split("/").filter((x) => x);

  if (pathnames[0] === "category" && pathnames.length === 3) {
    const [, categorySlug, subCategorySlug] = pathnames;
    const listingPath = `/category/${categorySlug}/${subCategorySlug}`;

    const rawCrumbs = [
      { label: humanize(categorySlug), to: listingPath },
      { label: humanize(subCategorySlug), to: null },
    ];

    const crumbs = rawCrumbs.filter((crumb, i) => {
      const prev = rawCrumbs[i - 1];
      return !prev || prev.label.toLowerCase() !== crumb.label.toLowerCase();
    });

    return (
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">Home</Link>
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <React.Fragment key={`${crumb.label}-${i}`}>
              <span className="breadcrumb-separator">/</span>
              {!isLast && crumb.to ? (
                <Link to={crumb.to} className="breadcrumb-link">
                  {crumb.label}
                </Link>
              ) : (
                <span className="breadcrumb-current">{crumb.label}</span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  // ── Product detail page: /tft/:categorySlug/:subCategorySlug/:partNoSlug ──
  if (pathnames[0] === "tft" && pathnames.length === 4) {
    const [, categorySlug, subCategorySlug, partNoSlug] = pathnames;
    const listingPath = `/category/${categorySlug}/${subCategorySlug}`;

    // Build the full crumb list first, then collapse consecutive entries
    // that resolve to the same display label (e.g. a category and
    // sub-category both happening to be named "5inch") — showing the same
    // word twice in a row is never useful, regardless of why the
    // underlying names happen to match.
   const rawCrumbs = [
  { label: humanize(categorySlug), to: listingPath },
  { label: humanize(subCategorySlug), to: null },
];

    const crumbs = rawCrumbs.filter((crumb, i) => {
      const prev = rawCrumbs[i - 1];
      return !prev || prev.label.toLowerCase() !== crumb.label.toLowerCase();
    });

    return (
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">Home</Link>
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <React.Fragment key={`${crumb.label}-${i}`}>
              <span className="breadcrumb-separator">/</span>
              {!isLast && crumb.to ? (
                <Link to={crumb.to} className="breadcrumb-link">
                  {crumb.label}
                </Link>
              ) : (
                <span className="breadcrumb-current">{crumb.label}</span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  // ── Everything else: generic fallback (static pages, etc.) ──
  // No more blind "tft" string-matching here — that was the actual bug,
  // since a real slug can legitimately equal "tft" too (as happened above).
  return (
    <div className="breadcrumb-container">
      <Link to="/" className="breadcrumb-link">
        Home
      </Link>

      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        // LANDING_PAGES_WIRED: friendly names for the static product landing pages.
        const STATIC_LABELS = { "hdmi-display": "HDMI Displays", "uart-display": "Smart UART Displays" };
        const label = STATIC_LABELS[value] || value.charAt(0).toUpperCase() + value.slice(1);
        const isLast = index === pathnames.length - 1;

        return (
          <React.Fragment key={to}>
            <span className="breadcrumb-separator">/</span>

            {isLast ? (
              <span className="breadcrumb-current">{label}</span>
            ) : (
              <Link to={to} className="breadcrumb-link">
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumb;